import React from "react";
import { Exercise } from "../../../models/Exercise";
import { format } from "date-fns";
import { useNavigate } from "react-router";
import { CINEMA_HALL_PAGE } from "../../../routes";
import getId from "../../../../utils/getId";

interface IProps {
  exerciseList: Exercise[];
  width?: string;
}

const SeansList: React.FC<IProps> = ({ exerciseList, width }: IProps) => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      {exerciseList.map((item, index) => (
        <button
          key={index}
          className={"btn-seans"}
          style={width ? { width: width } : {}}
          onClick={() =>
            navigate(
              `${CINEMA_HALL_PAGE}?exerciseIds=${getId(item)}&exerciseName=${item.name}&exerciseDate=${format(
                item.startTime,
                "dd-MM-yyyy, HH:mm"
              )}`
            )
          }
        >
          <p>{format(item.startTime, "HH:mm")}</p>
          <p>{item.description}</p>
        </button>
      ))}
    </React.Fragment>
  );
};

export default SeansList;
